import React from 'react';
import { badgeEntries, computePowerToughness, formatPowerToughness, hasCardValues } from '../utils/cardValues';
import './CardValues.css';

/**
 * Werte einer Karte außerhalb ihres Bildes (Spec 2026-10-21 §14): Stärke/Widerstandskraft
 * „Basis → mit Countern", alle Counter mit Zahl, alle Marken mit Name. Rendert nichts, wenn die
 * Karte keine Werte hat.
 *
 *   <CardValues card={card} variant="panel" as="aside" data-testid="preview-values" />
 *
 * - `variant="panel"`: Einträge untereinander (schwebende Vorschau, rechts neben dem Bild).
 * - `variant="row"`: Einträge nebeneinander mit Umbruch (Langdruck-Sheet, zwischen Karte und
 *   Aktionen).
 * - Reicht seine `ref` an das Wurzel-Element weiter (die Vorschau misst damit die Panel-Höhe).
 */
const CardValues = React.forwardRef(function CardValues(
  { card, variant = 'panel', as: Element = 'div', className = '', ...rest },
  ref,
) {
  if (!hasCardValues(card)) return null;
  const ptText = formatPowerToughness(computePowerToughness(card), { withBase: true });
  const entries = badgeEntries(card, { all: true });

  return (
    <Element ref={ref} className={`card-values card-values--${variant} ${className}`.trim()} {...rest}>
      {ptText && (
        <div className="card-values__pt">
          <span className="card-values__caption">Stärke/Widerstandskraft</span>
          <span className="card-values__pt-value">{ptText}</span>
        </div>
      )}
      {entries.length > 0 && (
        <ul className="card-values__list">
          {entries.map(({ key, label, text, icon: Icon }) => (
            <li key={key} className="card-values__entry">
              <Icon className="card-values__icon" aria-hidden />
              <span>{text ? `${label} ${text}` : label}</span>
            </li>
          ))}
        </ul>
      )}
    </Element>
  );
});

export default CardValues;
